<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="disabled"
        class="pl-0"
        small
        text
        v-on="on"
      >
        <flag :locale="currentLocale" />
        <v-icon
          class="ml-1"
          dark
          right
          size="10px"
        >fal fa-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-subheader>{{ $t('Change receipt language') }}</v-subheader>
      <v-list-item
        v-for="(locale, i) in locales"
        :key="i"
        @click="CHANGE_LANGUAGE(locale)"
      >
        <v-list-item-action><img :src="flagUrl(locale)"></v-list-item-action>
        <v-list-item-title>{{ $t(isoConv(locale)) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import isoConv from 'iso-language-converter'
import Flag from '@/components/Flag'

export default {
  name: 'LanguageSwitcher',

  components: {
    Flag
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    currentLocale: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isoConv
    }
  },

  computed: {
    ...mapGetters(['locales'])
  },

  methods: {
    ...mapActions('RECEIPT', ['CHANGE_LANGUAGE']),
    flagUrl (locale) {
      return `/static/images/flags/${locale}.png`
    }
  }
}
</script>

<style lang="scss" scoped>
  button {
    &:before{
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LanguageSwitcher.vue